import { Divider, Typography } from "@mui/material";
import styled, { css } from "styled-components";

export const Container = styled.div<{
  colorSelected?: boolean | null;
  pinSelected: boolean | undefined;
}>`
  display: flex;
  width: 437px;
  flex-direction: column;
  background: ${({ colorSelected }) => (colorSelected ? "#ffefea" : "#fafafa")};
  :hover {
    background: #ffffff;
  }

  ${({ pinSelected }) =>
    pinSelected
      ? css`
          border: 1px solid #d33100;
        `
      : css`
          border-bottom-color: rgba(0, 0, 0, 0.12);
          border-bottom-style: solid;
          border-bottom-width: 1px;
          box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
        `};

  min-height: 162px;
  min-height: auto;
  border-radius: 8px;
`;

export const CardContent = styled.button`
  display: flex;
  border: none;
  align-items: flex-start;
  cursor: pointer;
  justify-content: space-between;
  background: transparent;
  flex-direction: column;
  padding: 12px 16px;
`;

export const NameCard = styled(Typography)`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  text-align: left;
  font-weight: 500 !important;
`;

export const NameAdress = styled(Typography)`
  display: flex;
  padding-top: 5px;
  align-items: center;
  flex-direction: row;
  gap: 5px;
`;

export const NameLocale = styled(Typography)`
  display: flex;
  padding-top: 4px;
  padding-left: 25px;
  align-items: center;
  flex-direction: row;
  gap: 5px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ContainerTimer = styled.div`
  display: flex;
  height: 100%;
  min-width: 150px;
  align-items: flex-start;
  flex-direction: column;
  justify-content: space-between;
  padding-top: 3px;
`;

export const ContainerStatus = styled.div<{ colorTheme?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  padding: 3px 6px;
  margin-left: 5px;
  height: 24px;
  width: 145px;
  gap: 4px;

  border: 1px solid
    ${({ theme, colorTheme }) =>
      colorTheme === "primary"
        ? theme.palette.text.primary
        : theme.palette.warning.main};
  span {
    line-height: 0;
  }

  svg {
    color: ${({ theme }) => theme.palette.warning.main};
  }
`;

export const ButtonAcceptOrder = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  padding: 8px 90px;
  background: #d33100;
  width: 400px;
  height: 42px;
  border-radius: 21px;
  border: solid 1px #d33100;
  cursor: pointer;
  color: #ffffff;
  white-space: nowrap;
  align-self: center;
`;

export const ContainerColumn = styled.div`
  display: flex;
  width: 100%;
  align-items: flex-start;
  justify-content: space-between;
`;

export const ContainerRow = styled.div`
  display: flex;
  width: 100%;
  align-items: flex-end;
  justify-content: space-between;
`;

export const ContentRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

export const DividerContainer = styled(Divider)`
  margin: 8px 0 8px 0 !important;
`;

export const ContainerAutoComplete = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: auto;
  padding: 16px 16px;
`;

export const ButtonApplyDrive = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
  padding: 8px 24px;
  background: #d33100;
  height: 30px;
  border-radius: 15px;
  border: solid 1px #d33100;
  cursor: pointer;
  color: #ffffff;
`;

export const ContainerButtonsDrive = styled.div`
  display: flex;
  gap: 10px;
`;

export const ButtonBackDrive = styled.button`
  display: flex;
  background: none;
  justify-content: center;
  align-items: center;
  width: auto;
  padding: 8px 24px;
  height: 30px;
  border-radius: 15px;
  border: solid 1px rgba(0, 0, 0, 05);
  cursor: pointer;
`;

export const Button = styled.button`
  background: none;
  border: 0;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
`;

export const ContainerDriverSelected = styled.div`
  display: flex;
  width: 160px;
  align-items: center;
  gap: 10px;
`;

export const ContainerDriver = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

export const ContainerSelected = styled.div`
  display: flex;
  width: 300px;
`;

export const ButtonAccept = styled.button`
  display: flex;
  background: none;
  white-space: nowrap;
  justify-content: center;
  align-items: center;
  width: auto;
  padding: 8px 24px;
  height: 30px;
  border-radius: 15px;
  border: solid 1px rgba(0, 0, 0, 05);
  cursor: pointer;
`;

export const ContainerDrive = styled.div`
  display: flex;
  width: auto;
  padding: 16px 16px;
  justify-content: space-between;
`;

export const ContainerText = styled.div`
  display: flex;
  margin-top: -3px;
  flex-direction: column;
  h6 {
    display: flex;
    white-space: nowrap;
  }
`;

export const ButtonSelected = styled.button`
  display: flex;
  background: transparent;
  border: none;
  border-radius: 4px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const ContainerArrow = styled.div`
  display: flex;
  gap: 5px;
  justify-content: center;
  align-items: center;
`;
